<template>
    <div class="crud">
        <TheCrud :title="title" :store="store" :columns="columns" :can-delete="true" :init-query-params="{
        ['organization.id'] : organizationId
      }" :hidden-query-params="{ ['organization.id']: organizationId}" />
    </div>
</template>

<script>
import TheCrud from '@/components/crud/TheCrud'
export default {
  data() {
    return {
      title: this.$t("contact-me.chat-center.chat-dispositions"),
      store: "chatDispositions",
      columns: [
        { index : 'id', label : '#id', sortable : true},
        { index : 'name', label : this.$t('configuration.organization.name') },
        { index : 'description', label : this.$t('administration.clients.description') },
        { index: 'department.name', label : this.$t('contact-me.chat-center.department')}
      ]
    }
  },
  components: {
    TheCrud
  },
  computed: {
    organizationId() {
      return this.$store.getters["contactMe/getOrganizationId"];
    }
  }
};
</script>